var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuizShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 414,
    height: 374,
    viewBox: "0 0 414 374",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M511.723 5.7212C523.09 60.2143 534.711 172.886 490.259 187.626C434.695 206.052 409.049 39.7693 322.079 68.61C235.109 97.4507 254.947 254.31 196.967 273.537C138.987 292.764 268.951 49.9086 137.287 93.5702C5.62392 137.232 194.192 309.642 81.855 346.894C-30.4818 384.147 27.7043 66.3505 -92.1947 262.739",
    stroke: "#161F21",
    strokeWidth: 48
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizShape);
export default __webpack_public_path__ + "static/media/QuizShape.c312b65a968c39ae12cffb1b64ecf9a9.svg";
export { ForwardRef as ReactComponent };